module.exports = __webpack_public_path__ + "images/animal-welfare-logo.svg";